import { render, staticRenderFns } from "./congratulation.vue?vue&type=template&id=dbcaaf14"
import script from "./congratulation.vue?vue&type=script&lang=js"
export * from "./congratulation.vue?vue&type=script&lang=js"
import style0 from "./congratulation.vue?vue&type=style&index=0&id=dbcaaf14&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports